<script lang="ts">
  import Blocks from "@components/blocks/Blocks.svelte";

  export let columns: any;
  export const type: "columns_block" = "columns_block";
  export const id: string = "";
</script>

<div
  class="container pt-12 lg:max-w-screen-xl flex flex-col md:flex-row gap-8 items-center"
>
  <Blocks blocks={columns} />
</div>
